import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const Users = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        setUser(authUser);
      } else {
        setUser(null);
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="container mx-auto px-8 py-10 mt-10">
      <h2 className="text-2xl font-bold mb-4">Users Page</h2>
      {isLoading ? (
        <p>Loading...</p>
      ) : user ? (
        <div>
          <p>User UID: {user.uid}</p>
          <p>Email: {user.email}</p>
          <p>Display Name: {user.displayName}</p>
          {/* Add more user attributes as needed */}
        </div>
      ) : (
        <p>No authenticated user found.</p>
      )}
    </div>
  );
};

export default Users;
